export enum DynamicFavoritesTemplateEnum {
	EMPTY_LIST = 'empty_list',
	PRIVATE_LIST = 'private_list',
	SIGNOUT_LIST = 'signout_list',
	VALID_LIST = 'valid_list'
}

export enum DynamicListTemplateEnum {
	LIST_DASHBOARD = 'list_dashboard',
	SIGNED_OUT_DASHBOARD = 'signed_out_dashboard',
}